export interface GcpKmsServiceAccounts {
  scanningServiceAccount?: string;
  gcsServiceAgent?: string;
  restoreServiceAccounts?: string[];
}

export function generateGcpKmsCommands(
  kmsKey: string,
  serviceAccounts: GcpKmsServiceAccounts
): string {
  const keyDisplay = kmsKey || '<KMS_KEY>';
  const { scanningServiceAccount, gcsServiceAgent, restoreServiceAccounts } =
    serviceAccounts;

  const commands = [
    ...buildScanningAccountBinding(keyDisplay, scanningServiceAccount),
    ...buildGcsAgentBinding(keyDisplay, gcsServiceAgent),
    ...buildRestoreAccountBindings(keyDisplay, restoreServiceAccounts),
  ];

  return commands.join('\n');
}

function buildScanningAccountBinding(
  kmsKey: string,
  scanningServiceAccount?: string
): string[] {
  return [
    '#!/bin/bash',
    '',
    `gcloud kms keys add-iam-policy-binding "${kmsKey}" \\`,
    `  --member="serviceAccount:${scanningServiceAccount || '<SCANNING_SERVICE_ACCOUNT>'}" \\`,
    '  --role="roles/cloudkms.cryptoKeyEncrypterDecrypter"',
    '',
  ];
}

function buildGcsAgentBinding(
  kmsKey: string,
  gcsServiceAgent?: string
): string[] {
  return [
    `gcloud kms keys add-iam-policy-binding "${kmsKey}" \\`,
    `  --member="serviceAccount:${gcsServiceAgent || '<GCS_SERVICE_AGENT>'}" \\`,
    '  --role="roles/cloudkms.cryptoKeyEncrypterDecrypter"',
  ];
}

function buildRestoreAccountBindings(
  kmsKey: string,
  restoreServiceAccounts?: string[]
): string[] {
  if (!restoreServiceAccounts || restoreServiceAccounts.length === 0) {
    return [];
  }

  const commands: string[] = [''];

  restoreServiceAccounts.forEach((sa, index) => {
    if (index > 0) commands.push('');
    commands.push(`gcloud kms keys add-iam-policy-binding "${kmsKey}" \\`);
    commands.push(`  --member="serviceAccount:${sa}" \\`);
    commands.push('  --role="roles/cloudkms.cryptoKeyDecrypter"');
  });

  return commands;
}
